import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Romantic%20tropical%20island%20sunset%20scene%20with%20palm%20trees%20silhouette%20against%20warm%20golden%20orange%20and%20pink%20sky%2C%20calm%20turquoise%20ocean%20water%20with%20soft%20waves%20gently%20touching%20white%20sandy%20beach%2C%20dreamy%20atmospheric%20haze%2C%20cinematic%20wide%20angle%20composition%2C%20fine%20art%20travel%20photography%20style%20with%20film%20grain%20texture%2C%20ethereal%20and%20serene%20mood&width=1800&height=900&seq=hero-love-island-2026&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 mb-4 md:mb-6 leading-tight">
          {siteInfo.name}
          <span className="block text-xl md:text-2xl lg:text-3xl font-normal mt-2 md:mt-3 text-background-50/90">
            {siteInfo.tagline}
          </span>
        </h1>
        <p className="text-sm md:text-base text-background-50/80 max-w-2xl mb-8 md:mb-10 leading-relaxed">
          探索最美爱情岛线路，为您精心规划浪漫行程。无论是蜜月旅行、情侣度假还是求婚之旅，我们提供完整的爱情岛线路攻略，涵盖交通、住宿、景点与特色体验，让每段旅程都成为难忘的爱情故事。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 md:gap-4">
          <Link
            to="/category/honeymoon"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full text-sm transition-all duration-200 whitespace-nowrap"
          >
            探索蜜月行程
          </Link>
          <Link
            to="/category/couple"
            className="px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-full text-sm backdrop-blur-sm border border-background-50/20 transition-all duration-200 whitespace-nowrap"
          >
            情侣度假攻略
          </Link>
        </div>

        <div className="flex items-center gap-6 md:gap-10 mt-10 md:mt-12">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold font-heading text-background-50">500+</p>
            <p className="text-xs md:text-sm text-background-50/70 mt-1">精品线路</p>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold font-heading text-background-50">50万+</p>
            <p className="text-xs md:text-sm text-background-50/70 mt-1">甜蜜旅客</p>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold font-heading text-background-50">99.8%</p>
            <p className="text-xs md:text-sm text-background-50/70 mt-1">好评率</p>
          </div>
        </div>
      </div>
    </section>
  );
}